import Component from 'gia/Component'

export default class ComponentMobileMenu extends Component {
  constructor(element) {
    super(element)
    // Menu Toggle
    this.toggle = element.querySelector('.c-mobile-menu__toggle')
    this.menu = element.querySelector('.c-mobile-menu__menu-wrapper')

    this.item = element.querySelectorAll(
      '.c-mobile-menu__menu-item a:not([href="#"]'
    )
    this.child = element.querySelectorAll(
      '.c-mobile-menu__menu-child a:not([href="#"])'
    )
    this.childToggle = element.querySelectorAll('.c-mobile-menu__arrow')
  }

  init() {
    this.toggle.addEventListener('click', this.toggleMenu.bind(this))
    this.item.forEach(item => {
      item.addEventListener('click', this.toggleMenu.bind(this))
    })
    this.child.forEach(child => {
      child.addEventListener('click', this.toggleMenu.bind(this))
    })
    this.childToggle.forEach(toggle => {
      const parent = toggle.parentNode
      const dropdown = parent.querySelector('.c-mobile-menu__menu-child')
      toggle.addEventListener('click', event => {
        event.preventDefault()
        dropdown.classList.contains('c-mobile-menu__menu-child--hidden')
          ? dropdown.classList.remove('c-mobile-menu__menu-child--hidden')
          : dropdown.classList.add('c-mobile-menu__menu-child--hidden')
        toggle.classList.contains('c-mobile-menu__arrow--inactive')
          ? toggle.classList.remove('c-mobile-menu__arrow--inactive')
          : toggle.classList.add('c-mobile-menu__arrow--inactive')
      })
    })
  }

  toggleMenu() {
    // Menu Wrapper
    if (this.menu.classList.contains('c-mobile-menu__menu-wrapper--closed')) {
      this.menu.classList.remove('c-mobile-menu__menu-wrapper--closed')
      this.menu.classList.add('c-mobile-menu__menu-wrapper--open')
      $('body').css('overflow-y', 'hidden')
    } else {
      this.menu.classList.remove('c-mobile-menu__menu-wrapper--open')
      this.menu.classList.add('c-mobile-menu__menu-wrapper--closed')
      $('body').css('overflow-y', 'visible')
    }
    // Menu Toggle
    if (this.toggle.classList.contains('c-mobile-menu__toggle--closed')) {
      this.toggle.classList.remove('c-mobile-menu__toggle--closed')
      this.toggle.classList.add('c-mobile-menu__toggle--open')
    } else {
      this.toggle.classList.remove('c-mobile-menu__toggle--open')
      this.toggle.classList.add('c-mobile-menu__toggle--closed')
    }
  }

  mount() {
    this.init()
  }
}



// WEBPACK FOOTER //
// ./scripts/components/MobileMenu.js